export default "__VITE_ASSET__D4xSlGDu__"